import { render } from "./MessageSection.vue?vue&type=template&id=048f7838&scoped=true"
import script from "./MessageSection.vue?vue&type=script&lang=js"
export * from "./MessageSection.vue?vue&type=script&lang=js"

import "./MessageSection.vue?vue&type=style&index=0&id=048f7838&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048f7838"]])

export default __exports__